import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'evenNumber'
})
export class EvenNumberPipe implements PipeTransform {
    transform(periodo: number): string {
        if (periodo % 5 === 0) {
            return periodo.toString();
        }
        return '';
    }
}

